import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../../../../shared/services/auth/auth.service';
import { UserDataService } from '../../../../../shared/services/user-data/user-data.service';
import {
  ECONOMIC_STUDY_NAME,
  MIN_STATUS,
  WALL_IN_URL,
} from '../../../../../shared/utils/constants';
import { ErrorModelData } from '../../../../../vass-core/interfaces/error-model-data.interface';
import { EventModel } from '../../../../models/event.model';
import { AgentData } from '../../../../models/phone-agent.model';
import { AskStateService } from '../../../../services/ask-state/ask-state.service';
import { DashboardSectionService } from '../../../../services/dashboard-section/dashboard-section.service';

import { distinctUntilChanged } from 'rxjs/operators';
@Component({
  selector: 'app-ask-state',
  templateUrl: './ask-state.component.html',
  styleUrls: ['./ask-state.component.scss'],
  standalone: false,
})
export class AskStateComponent implements OnInit {
  public httpError = false;
  public collapseAsk = false;
  public error: ErrorModelData;
  public listEvents: Array<EventModel>;
  public status: number = 0;
  public statusMin = MIN_STATUS.validatingDocumentation;
  public wallUrl = WALL_IN_URL;
  public nameHolder = '';

  private hasSubscribeAgentData: boolean;
  public agentData: AgentData;

  constructor(
    private _askStateService: AskStateService,
    private authService: AuthService,
    private _dashboardSectionService: DashboardSectionService,
    public translateService: TranslateService,
    public userData: UserDataService,
    public router: Router,
  ) {}

  ngOnInit() {
    this.agentData = {
      phone: 'ask_state_phone_generic',
      mail: '',
    };
    // this.getEvents();
    this.updateStatus();
    // this._askStateService.getUpdateEvents().subscribe( data => { if (data) { this.getEvents(); } });
    this.userData.getSecondHolder().subscribe((user) => {
      if (user) {
        this.nameHolder = user.name;
      }
    });
    this.router.events.pipe(distinctUntilChanged()).subscribe((event: any) => {
      if (event.url !== '/dashboard') {
        this.collapseAsk = true;
      } else {
        this.collapseAsk = false;
      }
    });
  }

  private getEvents() {
    this._askStateService.getEvents().subscribe(
      (response) => {
        this.authService.setStatus(response.stateUx);
        if (response.subCategory === 'RJC') {
          // const event: Array<EventModel> = [{
          //     summary: 'Cumpliendo la nueva ley hipotecaria te informamos que tu solicitud de hipoteca ha sido rechazada.',
          //     type: 'alert',
          //     subType: 'warning',
          //     link: '',
          //     detail: ' '
          // }];
          // response.events = event;
          this.authService.setRejectedMortgage(true);
          this.authService.setRejectMortgageReasons(response.reason);
        } else {
          this.authService.setRejectedMortgage(false);
        }
        this.status = parseFloat(response.stateUx);
        if (this.status < 4) {
          this.generateYourRequestEvent();
        } else {
          this.listEvents = response.events;
        }
      },
      (error) => {
        this.status = 0;
        this.authService.setStatus(0);
        this.httpError = true;

        throw error;
      },
    );
  }

  private updateStatus() {
    this.authService.getUpdateStatus().subscribe((response) => {
      if (response) {
        this.getEvents();
        if (!this.hasSubscribeAgentData) {
          this.getPhoneAgent();
        }
      }
    });
  }

  private getPhoneAgent() {
    this.hasSubscribeAgentData = true;
    this._askStateService.getPhoneAgent().subscribe(
      (data) => {
        if (data) {
          this.agentData.mail = data.mail;
          this.agentData.phone = data.phone ? data.phone : 'ask_state_phone_generic';
        }
        this.hasSubscribeAgentData = false;
      },
      (err) => {
        this.hasSubscribeAgentData = false;
      },
    );
  }

  private generateYourRequestEvent() {
    const response = this._dashboardSectionService
      .getYourRequestSectionCacheData()
      .getValue();
    const event = this.getDocumentationEventTemplate();
    if (response && response.percentage < 15.0) {
      event.summary = 'MSG_EVENT_01';
      event.detail = 'MSG_EVENT_DETAIL_01';
      event.type = 'info';
    } else if (response && response.percentage >= 15.0 && response.percentage < 95.0) {
      event.summary = 'MSG_EVENT_02';
      event.detail = 'MSG_EVENT_DETAIL_02';
      event.type = 'info';
    } else {
      event.summary = 'MSG_EVENT_03';
      event.detail = 'MSG_EVENT_DETAIL_03';
      event.type = 'next';
    }
    this.listEvents = [event];
  }

  private getDocumentationEventTemplate(): EventModel {
    return {
      summary: '',
      detail: '',
      type: 'document',
      subType: 'info',
      link: ECONOMIC_STUDY_NAME,
      showDetails: false,
    };
  }

  public showEventDetails(item) {
    item.showDetails = !item.showDetails;
  }

  public getIcon(type: string) {
    switch (type) {
      case 'document': {
        return 'ic ic-document';
      }
      case 'idea': {
        return 'ic ic-idea';
      }
      case 'next': {
        return 'ic ic-arrow-right';
      }
      case 'info': {
        return 'ic ic-info';
      }
      case 'alert': {
        return 'ic ic-warning';
      }
      case 'calendar': {
        return 'ic ic-calendar2';
      }
      case 'envelope': {
        return 'ic ic-envelope';
      }
      case 'check': {
        return 'ic ic-check';
      }
      default: {
        return 'ic ic-info';
      }
    }
  }

  public getSeverity(subType: string) {
    switch (subType) {
      case 'info': {
        return 'row info';
      }
      case 'success': {
        return 'row success';
      }
      case 'warning': {
        return 'row warning';
      }
      default: {
        return 'row info';
      }
    }
  }

  public getLink(link: string) {
    switch (link) {
      case 'documentacion': {
        return 'documentacion';
      }
      case 'estudio-economico': {
        return 'estudio-economico';
      }
      case 'resultado': {
        return 'resultado';
      }
      case 'tasacion': {
        return 'tasacion';
      }
      case 'firma': {
        return 'firma';
      }
      default: {
        return '';
      }
    }
  }
}
